import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PWAThunk } from 'lib/core/data'
import { CartItem } from '../cart/types'
import { setCart } from '../cart'
import { triggerRemoveFromCart } from './gtm/triggerRemoveFromCart'
import { Slice, CartItemUpdateSlice } from './types'
import { Ga4Events } from '../../../../gtm/index'

export const initialState: Slice = {}

interface ActionData {
  cartItemId: string
}

const getSlice = (slice: CartItemUpdateSlice): CartItemUpdateSlice => {
  return slice ?? ({
    isFetching: false,
    isSuccess: false,
    isFailure: false
  })
}

const slice = createSlice({
  name: 'quote/cartItemRemove',
  initialState,
  reducers: {
    request (state, action: PayloadAction<ActionData>) {
      const { cartItemId } = action.payload
      const slice = getSlice(state[cartItemId])
      slice.isFetching = true
      state[cartItemId] = slice
    },

    success (state, action: PayloadAction<ActionData>) {
      const { cartItemId } = action.payload
      const slice = getSlice(state[cartItemId])
      slice.isFetching = false
      slice.isSuccess = true
      slice.isFailure = false
    },

    failure (state, action: PayloadAction<ActionData>) {
      const { cartItemId } = action.payload
      const slice = getSlice(state[cartItemId])
      slice.isFetching = false
      slice.isSuccess = false
      slice.isFailure = true
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function cartItemRemove (cartId: string, cartItem: CartItem): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    const { id: cartItemId } = cartItem
    dispatch(request({ cartItemId }))

    try {
      const response = await magentoClient.getClient().quote.removeCartItems({
        cartId,
        cartItemId
      })

      const { data } = response
      const { removeItemFromCart } = data
      const { cart } = removeItemFromCart

      if (cart) {
        triggerRemoveFromCart({ cartItem })
        Ga4Events.removeFromCart({ cartItems: [cartItem] })
        dispatch(setCart({
          cartId,
          data: cart
        }))
        dispatch(success({ cartItemId }))
      } else {
        dispatch(failure({ cartItemId }))
      }

      return response
    } catch (e) {
      dispatch(failure({ cartItemId }))
    }
  }
}
